import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import QuestionBox from '@/components/atom/icon/QuestionBox';

interface Props {
  handleClickRequestButton: () => void;
}

const DoctorResultEmpty = ({ handleClickRequestButton }: Props) => {
  return (
    <Container>
      <Wrapper>
        <QuestionBox />
        <EmptyResultTitle>{'찾으시는 정보가\n없으신가요?'}</EmptyResultTitle>
        <EmptyResultOffer>{`증상 / 과목을 선택하여\n진료 정보를 확인해보세요.`}</EmptyResultOffer>
        <ButtonSection>
          <Button onClick={handleClickRequestButton}>
            증상/과목 전체 보기
          </Button>
        </ButtonSection>
      </Wrapper>
    </Container>
  );
};

export default DoctorResultEmpty;

const Container = styled.div`
  display: inline-grid;
  width: 100%;
  height: calc(100vh - 168px);
  text-align: center;
  align-items: flex-start;
`;

const Wrapper = styled.div`
  padding: 80px 0 80px 0;
`;

const EmptyResultTitle = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI20SB};
    color: ${theme.color.gray600};
  `};

  margin-top: 24px;
  white-space: pre-wrap;
`;

const EmptyResultOffer = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI15R}
    color: ${theme.color.gray400};
  `};

  margin: 16px 0 20px 0;
  white-space: pre-wrap;
`;

const ButtonSection = styled.div`
  justify-content: center;
  display: flex;
`;

const Button = styled(DefaultButtonStyled)`
  width: 200px;
  height: 48px;
  padding: 0px 20px;
  border-radius: 8px;

  ${({ theme }) => `
    ${theme.typography.UI16SB};
    color: ${theme.color.white};
    background: ${theme.color.primary600};
  `}
`;
